import React from "react";
import { node } from "prop-types";
import EnvironmentErrorDialog from "./ErrorDialog";
import logToSentry from "ec/utils/logToSentry";

class EnvironmentErrorHandler extends React.Component {
  constructor() {
    super();
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    logToSentry(error, info);
  }

  render() {
    const { hasError } = this.state;
    if (hasError) {
      return <EnvironmentErrorDialog variant="default" />;
    }
    return this.props.children;
  }
}

EnvironmentErrorHandler.propTypes = {
  children: node.isRequired,
};

export default EnvironmentErrorHandler;
